<script>
  import Header from "./Header.svelte";
  import Who from "./Who.svelte";
  import Experience from "./Experience.svelte";
  import Ability from "./Ability.svelte";
  import Contact from "./Contact.svelte";
  import Footer from "./Footer.svelte";

  let mobileNavClass = "-translate-x-full";
  function toggleMobileNav(event) {
    mobileNavClass =
      mobileNavClass == "-translate-x-full" ? "" : "-translate-x-full";
  }

  /*if (localStorage.theme == "dark" || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
		document.documentElement.classList.add('dark');
	} else {
		document.documentElement.classList.remove('dark');
	}*/
</script>

<div class="relative min-h-screen md:flex">
  <!-- mobile menu bar -->
  <div class="bg-blue-800 text-gray-100 flex justify-between md:hidden">
    <!-- logo -->
    <a href="#header-section" class="block p-4 text-white font-bold"
      >Hugo Suissia</a
    >

    <!-- mobile menu button -->
    <button
      class="mobile-menu-button p-4 focus:outline-none focus:bg-blue-600"
      on:click={toggleMobileNav}
    >
    <svg
        class="h-5 w-5"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 12h16M4 18h16"
        />
      </svg>
    </button>
  </div>

  <!-- sidebar -->
  <div
    class="sidebar fixed bg-white text-blue-800 w-72 md:w-96 space-y-6 py-7 px-10 inset-y-0 left-0 z-50 transform {mobileNavClass} border-r border-gray-200 md:translate-x-0 transition duration-200 ease-in-out"
  >
    <!-- logo -->
    <a
    href="#header-section"
    class="text-blue-800 flex items-center space-x-2 px-4"
    >
      <img
        class="w-12 h-12"
        src="./images/logo.png"
        alt="Logo Hugo"
        width="16"
        height="16"
      />
      <span class="text-2xl font-extrabold">Hugo Suissia</span>
    </a>

    <!-- nav -->
    <nav>
      <a
        href="#who-section"
        class="block py-2.5 px-4 border-b border-transparent transition duration-200 hover:border-blue-700"
      >
        Qui suis-je ?
      </a>
      <a
        href="#experience-section"
        class="block py-2.5 px-4 border-b border-transparent transition duration-200 hover:border-blue-700"
      >
        Experiences
      </a>
      <a
        href="#ability-section"
        class="block py-2.5 px-4 border-b border-transparent transition duration-200 hover:border-blue-700"
      >
        Compétences
      </a>
      <a
        href="#contact-section"
        class="block py-2.5 px-4 border-b border-transparent transition duration-200 hover:border-blue-700"
      >
        Contact
      </a>

      <a
        href="./CV-HugoSuissia.pdf"
        class="block py-2.5 px-4 border-b border-transparent transition duration-200 mt-8 hover:border-blue-700"
        target="_blank"
      >
        [PDF] Mon CV
      </a>
    </nav>
    <button
      class="absolute top-0 right-1 md:hidden"
      on:click={toggleMobileNav}
    >
      <img
        class="w-8 h-8"
        src="./images/close.png"
        alt="Logo Hugo"
        width="16"
        height="16"
      />
  </button>
    
  </div>

  <!-- content -->
  <main class="bg-gray-100 w-full md:ml-96 ml-0">
    <Header />
    <Who />
    <Experience />
    <Ability />
    <Contact />
    <Footer />
  </main>
</div>

<style>
</style>
